import React from 'react';

const Info = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2801_393)">
        <path
          d="M8.00002 10.6483V8M8.00002 5.35172C8.00002 5.35172 8.00406 5.35172 8.00664 5.35172M14.6207 8C14.6207 11.6565 11.6565 14.6207 8.00002 14.6207C4.34352 14.6207 1.37933 11.6565 1.37933 8C1.37933 4.34349 4.34352 1.37931 8.00002 1.37931C11.6565 1.37931 14.6207 4.34349 14.6207 8Z"
          stroke="#2563EB"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2801_393">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Info;